import { Component, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { PATTERN } from '../pattern.constant';

@Component({
    selector: 'pickright-input',
    templateUrl: './input-control.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PickrightInputComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PickrightInputComponent
        }
    ]
})
export class PickrightInputComponent implements ControlValueAccessor, Validator {
    @Input() label: string;
    @Input() showLabel: boolean = true;
    @Input() placeholder: string = "";
    @Input() pattern: RegExp = null;//PATTERN.ALPHA_NUMARIC;
    @Input() patternError: string = "Only alpha numeric values required.";
    @Input() required: boolean;
    @Input() maxLength: Number;
    @Input() minLength: Number;
    @Input() minValue: Number; //for input type number
    @Input() maxValue: Number; //for input type number
    @Input() number: boolean = false;
    @Input() password: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() textarea: boolean = false;
    @Input() rows: Number = 3;
    @Input() value: any;
    @Input() cssClass: string;
    error: any;
    inValidState: boolean = false;
    isTouched: boolean = false;
    @Input() disabled: boolean = false;
    onChange = (value: any) => { };
    onTouched = () => { };
    onValidatorChange = () => { };
    constructor() {
    }
    validate(control: AbstractControl<any, any>): ValidationErrors | null {
        let error: ValidationErrors | null = null;
        if (this.number) {
            this.pattern = this.pattern || PATTERN.NUMBER;
            this.patternError = this.patternError || "Enter valid number."
        }
        if (this.isTouched && this.required && (!control.value || control.value.toString().trim().length == 0)) {
            error = {
                required: true
            };
        }
        else if (this.isTouched && this.pattern && !this.pattern.test(control.value)) {
            error = {
                pattern: true,
                message: this.patternError
            }
        } else if (this.isTouched && this.maxLength && (control.value.toString().trim().length) > this.maxLength) {
            error = {
                value: this.maxLength,
                maxLength: true
            }
        }
        else if (this.isTouched && this.minLength && control.value.toString().trim().length < this.minLength) {
            error = {
                value: this.minLength,
                minLength: true
            }
        }
        else if (this.isTouched && this.minValue && Number(this.minValue) > Number(control.value)) {
            error = {
                value: this.minValue,
                minValue: true,
                message: `Value can not be less than ${this.minValue}`
            }
        }
        else if (this.isTouched && this.maxValue && Number(this.maxValue) < Number(control.value)) {
            error = {
                value: this.maxValue,
                maxValue: true,
                message: `Value can not be greater than ${this.maxValue}`
            }
        }
        this.error = error;
       
        this.inValidState = this.error != null;
        return this.error;
    }
    registerOnValidatorChange?(onValidatorChange: () => void): void {
        this.onValidatorChange = onValidatorChange;
    }
    writeValue(value: any) {
        this.value = value;
    }
    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }
    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }
    markAsTouched() {
        if (!this.isTouched) {
            this.onTouched();
            this.isTouched = true;
        }
    }
    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }
    onValueChange() {
        this.onChange(this.number ?  (parseFloat(this.value) >=0 ? Number(this.value): null) : this.value);
    }

}
